import type { TimeSeriesPoint } from '@/features/_shared/chart/lib/buildChartLineSeries';
import type { SeriesData, SeriesRecord } from '@/features/_shared/chart/types/chartData';

export const aggregateTimeSeriesPoints = ({
  series,
  field,
  decimalPlaces,
  seriesDataAggregator
}: {
  series: SeriesData;
  field: string;
  decimalPlaces: number;
  seriesDataAggregator: (tsData: SeriesRecord, decimalPlaces: number) => TimeSeriesPoint;
}) => {
  const fieldData = (series as Partial<SeriesData>)[field];
  return (
    fieldData?.map(tsData => {
      return {
        ...seriesDataAggregator(tsData, decimalPlaces)
      };
    }) ?? []
  );
};
